import React, { Component, Fragment } from 'react';

import Level from './levels';


export default class GeneroContainer extends Component {

  getPng = (png) => {
    switch (png.toUpperCase()) {
      case 'RIÑA ENTRE COMPAÑEROS PERMANENTES':
      case 'RIÑA ENTRE ESPOSOS':
      case 'RIÑA ENTRE HIJO-PADRE':
      case 'RIÑA HIJO-MADRE':
      case 'RIÑAS': return 'ri%C3%B1as.png';
      case 'SICARIATO': return 'sicariato.png';
      case 'BATALEO':
      case 'ATRACO': return 'atraco.png';
      case 'VENTOSA': return 'ventosa.png';
      case 'COSQUILLEO': return 'cosquilleo.png';
      case 'SUPL. DIJIN-SIJIN':
      case 'ENGAÑO': return 'enga%C3%B1o.png';
      case 'FACTOR DE OPORTUNIDAD': return 'factor-oportunidad.png';
      case 'FLETEO': return 'fleteo.png';
      case 'SUSTRACCION EN MOVIMIENTO': return 'sustraccion-movimiento.png';
      case 'HALADO': return 'halado.png';
      case 'RAPONAZO': return 'raponazo.png';
      case 'USO SUSTANCIAS TOXICAS / ESCOPOLAMINADO': return 'sustancias-toxicas.png';
      case 'VIOLACION DE CERRADURA': return 'llave-maestra.png';
      case 'HERIDA CON ARMA BLANCA':
      case 'HERIDA POR ARMA CORTANTE EN REGION INTRACLAVICULAR IZQUIERDA':
      case 'ARMA BLANCA / CORTOPUNZANTE': return 'med-corta.png';
      case 'ARMA DE FUEGO': return 'med-arma.png';
      case 'ROMPIMIENTO DE VIDRIO': return 'rompimiento-vidrio.png';
      case 'CONTUNDENTES':
      case 'CONTUNDENTE': return 'med-contundente.png';
      case 'MADRUGADA': return 'j-madrugada.png';
      case 'MAÑANA': return 'j-ma%C3%B1ana.png';
      case 'NOCHE': return 'j-noche.png';
      case 'TARDE': return 'j-tarde.png';
      case 'RURAL': return 'z-rural.png';
      case 'URBANA': return 'z-urbana.png';
      case 'RESTO': return 'otros.png';
      case '0 - 13': return '0-13.png';
      case '14 - 17': return '14-17.png';
      case '18 - 27': return '18-27.png';
      case '28 - 59': return '28-59.png';
      case 'MÁS 60': return '60mas.png';
      case 'NO REPORTA':
      default: return 'no-reporta.png';
    }
  }

  getText = (text) => {
    let resp = text;
    switch (text) {
      case "HERIDA CON ARMA BLANCA".toLowerCase():
      case 'HERIDA POR ARMA CORTANTE EN REGION INTRACLAVICULAR IZQUIERDA'.toLowerCase():
      case 'arma blanca / cortopunzante': resp = 'arma blanca';
        break;
      case 'Mechero/Hormigueo'.toLowerCase(): resp = 'mechero';
        break;
      default: break;
    }
    if (resp.length > 15) {
      return resp.split(' ')[resp.split(' ').length - 1];
    }
    return resp;
  }

  getPercent = (val) => {
    const total = this.props.data.dataSet.reduce((a, b) => ({ value: a.value + b.value })).value;
    return val * 100 / total
  }
  getData = data => {
    if (data.length === 0)
      return [];
    if (data.length < 5)
      return data;
    let acum = 0;
    let otherData = [];
    for (let i = 0; i < data.length; i++) {
      if (i < 3) {
        otherData.push(data[i]);
        continue;
      }
      else {
        acum += data[i].value;
      }
      if (i === data.length - 1) {
        otherData.push({
          id: "resto",
          name: "resto",
          value: acum
        })
      }
    }
    return otherData;
  }
  getHeader = () => {
    try {
      return this.props.data.title.split(' - ')[1]
    } catch (e) {
      return ""
    }
  }

  render() {
    return (
      <Fragment>
        <div>
          {this.getHeader()}
        </div>
        {
          this.getData(this.props.data.dataSet).map((dato, index) => {
            if (index > 3)
              return (<Fragment />)
            return (
              <div key={'key-modalidad-' + this.props.name + '-' + index} className="modalidad-list">
                <div>
                  <Level
                    width={70}
                    height={this.props.height}
                    level={this.getPercent(dato.value)}
                    image={this.getPng(dato.name)}
                    colorTop={this.props.top}
                    colorBottom={this.props.button}
                    name={this.props.name + "-uno-" + index}
                  />
                  {dato.value}
                </div>
                <div>
                  {this.getText(dato.name.toLowerCase())}
                </div>
              </div>
            )
          })
        }
      </Fragment>
    )
  }
}